import { FILTERS_BAR_MAX_SLOTS } from './filtersTokens.js';

/** Filter `joinClasses` — same contract as `Menu/menu.utils.joinClasses`. */

export function joinClasses(...parts) {
  return parts.filter(Boolean).join(' ');
}

/** @param {import('./filtersTypes.js').FilterSortConfig | null | undefined} sort */
export function resolveSortDefaults(sort) {
  return {
    value: sort?.defaultValue ?? sort?.options?.[0]?.value,
    direction: sort?.defaultDirection ?? 'desc',
  };
}

/** Sort distinto del default → Clear Filters visible y reseteable. */
export function isSortDirty(sort) {
  if (!sort) return false;

  const { value: defaultValue, direction: defaultDirection } = resolveSortDefaults(sort);
  const valueDirty =
    defaultValue != null && sort.value != null && sort.value !== defaultValue;
  const directionDirty = (sort.direction ?? 'desc') !== defaultDirection;

  return valueDirty || directionDirty;
}

/**
 * @param {number | undefined} maxFilters — Tope absoluto (0–4)
 * @param {number | undefined} responsiveLimit — Tope por viewport (0–4)
 */
export function resolveBarFilterSlotLimit(maxFilters, responsiveLimit) {
  const cap = maxFilters ?? FILTERS_BAR_MAX_SLOTS;
  const capped = Math.min(FILTERS_BAR_MAX_SLOTS, Math.max(0, cap));
  const responsive =
    responsiveLimit == null
      ? FILTERS_BAR_MAX_SLOTS
      : Math.min(FILTERS_BAR_MAX_SLOTS, Math.max(0, responsiveLimit));

  return Math.min(capped, responsive);
}

/** @param {number | undefined} maxFilters */
export function resolveMaxVisibleFilters(maxFilters) {
  return resolveBarFilterSlotLimit(maxFilters, FILTERS_BAR_MAX_SLOTS);
}

/**
 * @param {import('./filtersTypes.js').FilterSlotConfig[]} filters
 * @param {number | undefined} maxFilters
 * @param {number | undefined} [responsiveLimit]
 */
export function partitionBarFilters(filters, maxFilters, responsiveLimit) {
  const limit = resolveBarFilterSlotLimit(maxFilters, responsiveLimit);
  const list = Array.isArray(filters) ? filters : [];

  if (limit === 0) {
    return { barFilters: [], overflowFilters: list, barSlotLimit: 0 };
  }

  return {
    barFilters: list.slice(0, limit),
    overflowFilters: list.slice(limit),
    barSlotLimit: limit,
  };
}
